import { Outlet } from "react-router-dom";

const CommunicationParentPage = () => {
    return <Outlet />;
};

export default CommunicationParentPage;
